import type { CoordinationFleetContext } from './types';
import type { ExecutionProgressHydration } from '../executionOperations/types';

/** Map E2.4a backend coordination hydration to E2.3 fleet context. */
export function mapCoordinationHydrationToFleet(
  hydration: ExecutionProgressHydration
): CoordinationFleetContext | undefined {
  const ctx = hydration.coordinationContext;
  if (!ctx) return undefined;

  return {
    currentRouteId: ctx.currentRouteId,
    driverId: ctx.driverId,
    vehicleId: ctx.vehicleId,
    trailerVehicleId: ctx.trailerVehicleId,
    relatedRoutes: ctx.relatedRoutes.map((r) => ({
      routeId: r.routeId,
      routeNumber: r.routeNumber,
      status: r.status,
      driverId: r.driverId,
      vehicleId: r.vehicleId,
      plannedLoadingDate: r.plannedLoadingDate,
      plannedUnloadingDate: r.plannedUnloadingDate,
      executionComplete: false
    }))
  };
}
